<template>
  <div class="wysiwyg">
    <component :is="cpt" />
  </div>
</template>

<script setup lang="ts">
import { compile, h } from 'vue'
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
})

const cpt = h(compile(props.content.htmltext))
</script>

<style lang="scss" scoped>
.wysiwyg:not(.wrapper) {
  margin: auto;

  @include mq(l) {
    width: col(8);

    .wrapper & {
      margin: 0 0 0 auto;
    }
  }

  @include mq($until: l) {
    width: 100%;
  }
}
</style>
